module.exports = __webpack_public_path__ + "img/device_c4_one.816ed02d.jpg";